import { FC } from 'react'
import { DraftRequestReviewStatus } from './types/types'
import styles from './Status.module.scss'

interface StatusProps {
  status: DraftRequestReviewStatus
}

const Status: FC<StatusProps> = ({ status }) => {
  const statusClasses = {
    [DraftRequestReviewStatus.PENDING]: styles.pending,
    [DraftRequestReviewStatus.APPROVED]: styles.approved,
    [DraftRequestReviewStatus.REJECTED]: styles.rejected,
    [DraftRequestReviewStatus.FLAGGED]: styles.flagged,
  }

  return <div className={`${styles.status} ${statusClasses[status]}`}>{status.replace('_', ' ')}</div>
}

export default Status
